import {SmartComponent} from "smart-component-js";


class ArticleInfoComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.position = this.element.querySelector('.article-info__details');

        this.init();
    }

    createBanner() {
        let html = '';

        html += ` 
   <div class="column column-9">
        <div class="dlovers-banner">
  
            <div class="dlovers-banner__background show-desktop"
                 style="background-image: url('${GENERIC_TRANSLATIONS.dloversBannerDesktopImgUrl}')"></div>
    
            <div class="dlovers-banner__background show-mobile"
                 style="background-image: url('${GENERIC_TRANSLATIONS.dloversBannerMobileImgUrl}')"></div>

            <div class="dlovers-banner__wrapper">
                <div class="dlovers-banner__copy">
                    <div class="dlovers-banner__title">${GENERIC_TRANSLATIONS.dloversBannerTitle}</div>
                    <div class="dlovers-banner__subtitle">${GENERIC_TRANSLATIONS.dloversBannerSubtitle}</div>
                </div>
                <div class="dlovers-banner__cta tertiary-button">
                    <a href="${GENERIC_TRANSLATIONS.dloversBannerCtaHref}" target="_blank">${GENERIC_TRANSLATIONS.dloversBannerCtaLabel}</a>
                </div>
            </div>

        </div>
    </div>`

        this.position.insertAdjacentHTML('afterend', html);
    }


    init() {
        this.createBanner()
    }
}

export default ArticleInfoComponent;
